import { CmsObjectWithDefault } from '@components/Cms/types';

export type DeleteAccountViewCmsKey =
    | 'DeleteAccountTopic'
    | 'DeleteAccountLegal1'
    | 'DeleteAccountLegal2'
    | 'DeleteAccountNote1'
    | 'DeleteAccountNote2'
    | 'DeleteAccountButton'
    | 'Warning1'
    | 'Warning2'
    | 'DeleteAccountContents';

export const DeleteAccountViewCmsWithDefault: CmsObjectWithDefault<DeleteAccountViewCmsKey> = {
    DeleteAccountTopic: {
        cmsId: 155204,
        defaultTranslation: 'You are about to delete your account',
    },
    DeleteAccountLegal1: {
        cmsId: 155205,
        defaultTranslation:
            'By clicking on the "Delete my account" button below, you voluntarily choose to delete your account entirely and irreversibly, and you agree to assume sole responsibility for all consequences relating to the deletion of your account.',
    },
    DeleteAccountLegal2: {
        cmsId: 155206,
        defaultTranslation: 'By deleting your account, Agoda will:',
    },
    Warning1: {
        cmsId: 155207,
        defaultTranslation: 'Delete all information on your profile',
    },
    Warning2: {
        cmsId: 155208,
        defaultTranslation: 'Delete all information regarding past bookings',
    },
    DeleteAccountNote1: {
        cmsId: 155209,
        defaultTranslation: 'Please note,',
    },
    DeleteAccountNote2: {
        cmsId: 155210,
        defaultTranslation:
            'if 120 days have not passed since your last booking date or check-out date, we cannot delete your account immediately due to auditing purposes. We will register your account deletion petition and proceed with the deletion of your account 120 days after your last booking or check-out date.',
    },
    DeleteAccountButton: {
        cmsId: 356652,
        defaultTranslation: 'Delete my account',
    },
    DeleteAccountContents: {
        cmsId: 264398,
        defaultTranslation:
            'You are about to delete your account \n\nBy clicking on the "Delete my account" button below, you voluntarily choose to delete your account entirely. The deletion of your account is permanent and impacts several items such as but not limited to:\n \n• You will no longer be able to access your Agoda account and no reinstatement is possible.\n• Unused rewards points (e.g., Cash Back), refunds, or Agoda Cash will be permanently forfeited.\n• Deleting your account may impair and limit any future (customer) services that we can render.\n \nPlease note, we take the position to hold personal data for 120 days after guest\'s last checkout date for business, legal, accounting and auditing purposes. We will register your account deletion request and proceed with the deletion 120 days after your last checkout date.',
    },
};
